import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Deliveredappsdubai() {
  return (
    <section
      className="delivered_apps_dubai p-100"
      style={{ background: "#FBFBFB" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={8} xxl={8}>
            <h2>
              We've Delivered 200+ Mobile App Solutions Across Multiple
              Industries!
            </h2>
            <p>
              Partner up with TekRevol to upscale your business prospect with a
              purpose-built app solution.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book Your Free Consultation Today
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="delivered_apps_img">
              <Link
                to="https://goo.gl/maps/wDiGPbbTyqVw4BqF9"
                target="_blank"
                rel="noopener"
              >
                <StaticImage
                  src="../../images/locationgcc/dubai_new/dubai_apps_map.webp"
                  alt="tekrevol_web"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={732}
                  height={514}
                />
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Deliveredappsdubai;
